

























































































































































































import Component from "vue-class-component";
import Vue from "vue";
import {RestService} from "../../../node-backend-frontend/src/public/services/rest.service";
import {Configs} from "../configs";
import {ProjectMetaData} from "../model/interface/project.interface";
import {ProjectService} from "../services/project.service";
import {MessageBus} from "../services/messageBus";
import {AlertType} from "../model/enum/alert.enum";
import {BaseUrlService} from "../services/base-url.service";

@Component
export default class ScriptGeneratorComponent extends Vue {

  private alertSuccess: HTMLDivElement;
  private alertError: HTMLDivElement;
  private alertSuccessText: HTMLSpanElement;
  private alertErrorText: HTMLSpanElement;

  private generatorFirstNameInput: HTMLInputElement;
  private generatorLastNameInput: HTMLInputElement;
  private generatorTypeSelect: HTMLSelectElement;
  private generatorTagInput: HTMLInputElement;
  private generatorShowSelectBoxesCheckBox: HTMLInputElement;
  private generatorShowLastUpdateCheckBox: HTMLInputElement;
  private generatorBaseURLInput: HTMLInputElement;
  private generatorPubIdInput: HTMLInputElement;
  private generatorOutputTextArea: HTMLTextAreaElement;
  private generatorSortingAddBtn: HTMLButtonElement;
  private generatorSorting: HTMLDivElement;

  private generatorPubEntryAddBtn: HTMLButtonElement;
  private generatorPubEntryContainer: HTMLDivElement;

  private generatorPubEntriesLineHeight: HTMLInputElement;
  private generatorPubEntriesPaddingLeft: HTMLInputElement;

  private projectMetaData: ProjectMetaData[] = [];
  private selectedProjectAlias: number = null;
  private baseURL: string = "";

  async mounted() {
    let result: ProjectMetaData[] = [];
    try {
      result = await ProjectService.getAllProjectMetaData();
      if(!this.projectMetaData) {
        MessageBus.$emit(AlertType[AlertType.error], 'Error during Project Metadata fetch!');
        return;
      }
      this.projectMetaData = result;
    } catch (e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during Project Metadata fetch!');
      return;
    }

    this.generatorFirstNameInput = <HTMLInputElement>document.getElementById('wimpub_admin_generator_first_name');
    this.generatorLastNameInput = <HTMLInputElement>document.getElementById('wimpub_admin_generator_last_name');
    this.generatorTypeSelect = <HTMLSelectElement>document.getElementById('wimpub_admin_generator_types');
    this.generatorTagInput = <HTMLInputElement>document.getElementById('wimpub_admin_generator_tags');
    this.generatorShowSelectBoxesCheckBox = <HTMLInputElement>document.getElementById('wimpub_admin_generator_show_select_boxes');
    this.generatorShowLastUpdateCheckBox = <HTMLInputElement>document.getElementById('wimpub_admin_generator_show_last_update');
    this.generatorBaseURLInput = <HTMLInputElement>document.getElementById('wimpub_admin_generator_baseURL');
    this.generatorPubIdInput = <HTMLInputElement>document.getElementById('wimpub_admin_generator_pubId');
    this.generatorOutputTextArea = <HTMLTextAreaElement>document.getElementById('wimpub_admin_generator_output');
    this.generatorSortingAddBtn = <HTMLButtonElement>document.getElementById('wimpub_admin_generator_sorting_add');
    this.generatorSorting = <HTMLDivElement>document.getElementById('wimpub_admin_generator_sorting');
    this.generatorPubEntryContainer = <HTMLDivElement>document.getElementById('wimpub_admin_generator_pubEntry_container');
    this.generatorPubEntryAddBtn = <HTMLButtonElement>document.getElementById('wimpub_admin_generator_pubEntry_add');
    this.generatorPubEntriesLineHeight = <HTMLInputElement>document.getElementById('wimpub_admin_generator_pubentries_lineHeight');
    this.generatorPubEntriesPaddingLeft = <HTMLInputElement>document.getElementById('wimpub_admin_generator_pubentries_paddingLeft');

    this.alertSuccess = <HTMLDivElement>document.getElementById('wimpub_admin_alert_success');
    this.alertError = <HTMLDivElement>document.getElementById('wimpub_admin_alert_error');
    this.alertSuccessText = <HTMLSpanElement>document.getElementById('wimpub_admin_alert_success_text');
    this.alertErrorText = <HTMLSpanElement>document.getElementById('wimpub_admin_alert_error_text');

    this.populateTypes();


    if(this.$route.params && this.$route.params.id) {
      const id: number = Number.parseInt(this.$route.params.id);
      if(!id) {
        console.error("Could not parse Routing ID in Path");
        return;
      }
      this.selectedProjectAlias = id;
    }

    try {
      const baseURL = await BaseUrlService.getBaseURL();
      if(!baseURL) {
        MessageBus.$emit(AlertType[AlertType.error], 'Error during BaseURL fetch!');
        return;
      }
      this.baseURL = baseURL;
    } catch (e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during BaseURL fetch!');
      return;
    }
  }


  private generateHTMLPubView() {
//filter current Values
    let firstName = '*';
    let lastName = '*';
    let tag = '*';
    const type = this.generatorTypeSelect.options[this.generatorTypeSelect.selectedIndex].label;
    const showSelectBoxes: boolean = this.generatorShowSelectBoxesCheckBox.checked;
    const showLastUpdated: boolean = this.generatorShowLastUpdateCheckBox.checked;
    const pubElementId: string = this.generatorPubIdInput.value;
    const sorting: string = this.generateSortingRules();

    if (this.generatorFirstNameInput.value) {
      firstName = this.generatorFirstNameInput.value;
    }
    if (this.generatorLastNameInput.value) {
      lastName = this.generatorLastNameInput.value;
    }
    if (this.generatorTagInput.value) {
      tag = this.generatorTagInput.value;
    }

    const script: string = 'script';

    this.generatorOutputTextArea.value = `
      <br>
      <div class="uzk15__grid_100 uzk15__defaultgrid">
      <h2 class="uzk15__standard_h2">Publikationen</h2>
      <div id='${pubElementId}'></div>
      </div>

      <${script} type="text/javascript" src="${this.baseURL}/PublicationsApp.bundle.js"></${script}>
      <${script} type="text/javascript">
        window.PublicationsApp.PublicationsApi.initPublicationsView({
          author: {"lastName": "${lastName}", "firstName": "${firstName}"},
          type: '${type}',
          tag: '${tag}',
          sorting: ${sorting},
          showSelectBoxes: ${showSelectBoxes},
          showLastUpdate: ${showLastUpdated},
          baseURL: '${this.baseURL}/${this.selectedProjectAlias}',
          pubElementId: '${pubElementId}'
        });
      </${script}>`;

    if(!this.selectedProjectAlias) {
      alert('No Project selected!');
    }
  }

  //Put the available Types into the Selection-Node
  private async populateTypes() {
    let result: any = [];
    let types: string[] = ['attachment', 'book', 'bookSection', 'conferencePaper', 'document', 'journalArticle', 'newspaperArticle', 'report', 'thesis'];
    //TODO: Evtl. Types per API Abfragen ?

    //Populate '*'
    let option: HTMLOptionElement = document.createElement('option');
    option.label = '*';
    option.innerHTML = '*';
    this.generatorTypeSelect.appendChild(option);

    types.forEach((type: string) => {
      let option: HTMLOptionElement = document.createElement('option');
      option.label = type;
      option.innerHTML = type;
      this.generatorTypeSelect.appendChild(option);
    });
  }

  // Copies the text in the textArea to the clipboard
  private copyToClipboard() {
    let testingCodeToCopy: any = document.querySelector('#wimpub_admin_generator_output');
    if (!testingCodeToCopy) {
      return;
    }
    testingCodeToCopy.setAttribute('type', 'text');
    testingCodeToCopy.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      alert('Code was copied to clipboard');
    } catch (err) {
      alert('Unable to copy');
    }

    /* unselect the range */
    testingCodeToCopy.setAttribute('type', 'hidden');

    const selection: Selection | null = window.getSelection();
    if (!selection) {
      return;
    }
    selection.removeAllRanges();
  }

  private addSortingRule() {
    let option: HTMLDivElement = document.createElement('div');

    //Sorting Type
    let sortingTypeContainer: HTMLDivElement = document.createElement('div');
    sortingTypeContainer.classList.add('md-layout-item');

    //Sorting Type Label
    let describtionType: HTMLSpanElement = document.createElement('span');
    describtionType.innerHTML = 'Type';
    sortingTypeContainer.appendChild(describtionType);

    //Sorting Dropdown
    let sortingType: HTMLSelectElement = document.createElement('select');
    let sortingTypeDate: HTMLOptionElement = document.createElement('option');
    let sortingTypeItemType: HTMLOptionElement = document.createElement('option');
    sortingTypeDate.label = 'date';
    sortingTypeItemType.label = 'itemType';

    sortingType.classList.add('wimpub_admin_sortingType');
    sortingType.appendChild(sortingTypeDate);
    sortingType.appendChild(sortingTypeItemType);
    sortingTypeContainer.appendChild(sortingType);


    //Sorting Direction Container
    let sortingDirContainer: HTMLDivElement = document.createElement('div');
    sortingDirContainer.classList.add('md-layout-item');

    //Sorting Direction Label
    let describtionDir: HTMLSpanElement = document.createElement('span');
    describtionDir.innerHTML = 'Direction';

    //Sorting Direction
    let descriptionDirValueContainer: HTMLDivElement = document.createElement('div');
    let sortingDir: HTMLSelectElement = document.createElement('select');
    let sortingDirASC: HTMLOptionElement = document.createElement('option');
    let sortingDirDESC: HTMLOptionElement = document.createElement('option');
    sortingDirASC.label = 'ASC';
    sortingDirDESC.label = 'DESC';
    sortingDir.appendChild(sortingDirASC);
    sortingDir.appendChild(sortingDirDESC);
    sortingDir.classList.add('wimpub_admin_sortingDir');
    descriptionDirValueContainer.appendChild(sortingDir);

    sortingDirContainer.appendChild(describtionDir);
    sortingDirContainer.appendChild(descriptionDirValueContainer);

    //Sorting Display
    let sortingDisplayContainer: HTMLDivElement = document.createElement('div');
    sortingDisplayContainer.classList.add('md-layout-item');

    //Sorting Display Label
    let descriptionDisplayContainer: HTMLDivElement = document.createElement('div');
    descriptionDisplayContainer.classList.add('md-layout');
    let describtionDisplay: HTMLSpanElement = document.createElement('span');
    describtionDisplay.innerHTML = 'Display';
    descriptionDisplayContainer.appendChild(describtionDisplay);

    let descriptionDisplayValueContainer: HTMLDivElement = document.createElement('div');
    descriptionDisplayValueContainer.classList.add('md-layout-item');
    let sortingDisplay: HTMLInputElement = document.createElement('input');
    sortingDisplay.type = 'checkbox';
    sortingDisplay.classList.add('wimpub_admin_sortingDisplay');
    descriptionDisplayValueContainer.appendChild(sortingDisplay);
    sortingDisplayContainer.appendChild(descriptionDisplayContainer);
    sortingDisplayContainer.appendChild(describtionDisplay);
    sortingDisplayContainer.appendChild(descriptionDisplayValueContainer);

    //Delete Button
    let sortingDeleteContainer: HTMLDivElement = document.createElement('div');
    sortingDeleteContainer.classList.add('md-layout-item');
    let deleteBtn: HTMLButtonElement = document.createElement('button');
    deleteBtn.innerHTML = "Delete";
    deleteBtn.classList.add('md-accent', 'md-raised', 'md-button', 'md-theme-default');
    deleteBtn.addEventListener('click', () => {
      if (!option.parentNode) {
        return;
      }
      option.parentNode.removeChild(option);
    });
    sortingDeleteContainer.appendChild(deleteBtn);

    option.appendChild(sortingTypeContainer);
    option.appendChild(sortingDirContainer);
    option.appendChild(sortingDisplayContainer);
    option.appendChild(sortingDeleteContainer);

    option.classList.add('wimpub_admin_sorting_container');
    option.classList.add('md-layout');

    this.generatorSorting.appendChild(option);
  }

  private addPubEntry() {
    let pubEntryContainer: HTMLDivElement = document.createElement('div');

    let pubEntryInputContainer: HTMLDivElement = document.createElement('div');
    pubEntryInputContainer.classList.add('md-layout-item');

    let pubEntryInputLabelContainer: HTMLDivElement = document.createElement('div');
    pubEntryInputLabelContainer.classList.add('md-layout-item');

    let pubEntryDeleteBtnContainer: HTMLDivElement = document.createElement('div');
    pubEntryDeleteBtnContainer.classList.add('md-layout-item');

    let pubEntryInput: HTMLInputElement = document.createElement('input');
    let pubEntryInputLabel: HTMLSpanElement = document.createElement('span');

    pubEntryInputContainer.appendChild(pubEntryInput);
    pubEntryInputLabelContainer.appendChild(pubEntryInputLabel);
    pubEntryInputContainer.appendChild(pubEntryInput);

    pubEntryInput.classList.add('wimpub_pub_entry');
    pubEntryInputLabel.innerText = 'ID';

    //Delete Button
    let deleteBtn: HTMLButtonElement = document.createElement('button');
    deleteBtn.innerHTML = "Delete";
    deleteBtn.classList.add('md-accent', 'md-raised', 'md-button', 'md-theme-default');
    deleteBtn.addEventListener('click', () => {
      if (!pubEntryContainer.parentNode) {
        return;
      }
      pubEntryContainer.parentNode.removeChild(pubEntryContainer);
    });

    pubEntryDeleteBtnContainer.appendChild(deleteBtn);

    pubEntryContainer.appendChild(pubEntryInputLabelContainer);
    pubEntryContainer.appendChild(pubEntryInputContainer);
    pubEntryContainer.appendChild(pubEntryDeleteBtnContainer);

    pubEntryContainer.classList.add('wimpub_admin_sorting_container');
    pubEntryContainer.classList.add('md-layout');
    /*    pubEntryContainer.style.alignItems = 'center';*/

    this.generatorPubEntryContainer.appendChild(pubEntryContainer);
  }


  private generateSortingRules(): string {

    //search for current sorting Rules in the DOM
    if (!this.generatorSorting.children) {
      return "";
    }

    let result: string = "[";
    for (let i = 0; i < this.generatorSorting.children.length; i++) {
      result += "{";
      const child: HTMLDivElement = <HTMLDivElement>this.generatorSorting.children[i];
      const types: HTMLSelectElement = <HTMLSelectElement>child.getElementsByClassName('wimpub_admin_sortingType');

      let type = (<HTMLSelectElement>(types.item(0))).options[(<any>types[0]).selectedIndex].label;
      result += `type: '${type}',`;
      const dirs: HTMLSelectElement = <HTMLSelectElement>child.getElementsByClassName('wimpub_admin_sortingDir');
      let dir = (<any>dirs[0]).options[(<any>dirs[0]).selectedIndex].label;


      result += `direction: '${dir}',`;
      const displays: any = child.getElementsByClassName('wimpub_admin_sortingDisplay');
      let display = displays[0].checked;
      result += `display: ${display}`;
      result += "}";
      if (i != this.generatorSorting.children.length - 1) {
        result += ",";
      }
    }

    result += "]";
    return result;
  }

  private generatePubEntries() {

    //search for current sorting Rules in the DOM
    if (!this.generatorPubEntryContainer.children) {
      return "";
    }

    let result: string = "";
    for (let i = 0; i < this.generatorPubEntryContainer.children.length; i++) {
      const child: HTMLDivElement = <HTMLDivElement>this.generatorPubEntryContainer.children[i];
      const entry: any = child.getElementsByClassName('wimpub_pub_entry');
      result += `<div class='wimpub_pub_entry' id='${entry[0].value}'></div>
        `;
    }

    return result;
  }

  private generateHTMLPubEntries() {
    //filter current Values
    const lineHeight: string = this.generatorPubEntriesLineHeight.value;
    const paddingLeft: string = this.generatorPubEntriesPaddingLeft.value;
    const pubEntries: string = this.generatePubEntries();

    const script: string = 'script';
    this.generatorOutputTextArea.value = `${pubEntries}
        <${script} type="text/javascript" src="${this.baseURL}/PublicationsApp.bundle.js"></${script}>

        <${script} type="text/javascript">
        window.PublicationsApi.PublicationsApi.initLoadPubEntries({
        lineHeight : '${lineHeight}',
        paddingLeft : '${paddingLeft}',
        baseURL: '${this.baseURL}/${this.selectedProjectAlias}'
        });
      </ ${script}>`;

  }


}
